import '../scripts/sentry';
import '../scripts/distro-direct';
import '@hotwired/turbo-rails';
import * as ActiveStorage from '@rails/activestorage';
import '../scripts/turbo-stream-actions';
import '../controllers';
import * as DirectUploadLoader from '../scripts/direct-upload-loader';
import * as DirectUploadDisableOnModals from '../scripts/direct-upload-disable-on-modals';

DirectUploadLoader.start(); // must be before ActiveStorage.start()
DirectUploadDisableOnModals.startBeforeActiveStorage();
ActiveStorage.start();
DirectUploadDisableOnModals.startAfterActiveStorage();
